(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  const timelines = document.querySelectorAll('.timeline');
  timelines.forEach(timeline => {
    const items = timeline.querySelectorAll('.timeline__item:not(.timeline__item--clone)');
    const clones = timeline.querySelectorAll('.timeline__item--clone');
    if (window.matchMedia('(min-width: 750px)').matches && items.length > 5) {
      // Set fixed widths for scrolling timeline
      items.forEach(item => { item.style.flex = '0 0 calc(100% / 5)'; item.style.minWidth = 'calc(100% / 5)'; });
      clones.forEach(clone => { clone.style.display = 'flex'; clone.style.flex = '0 0 calc(100% / 5)'; clone.style.minWidth = 'calc(100% / 5)'; });
      let paused = false;

      // The reset point is where the cloned items start (after original items + repeat card)
      // We calculate the width of the original items to know when to reset
      function getResetPoint() {
        let width = 0;
        items.forEach(item => { width += item.offsetWidth; });
        // Add the repeat card width (first clone)
        if (clones.length > 0) width += clones[0].offsetWidth;
        return width;
      }

      function autoScroll() {
        if (!paused) {
          timeline.scrollLeft += 0.3;
          const resetPoint = getResetPoint();
          if (timeline.scrollLeft >= resetPoint) {
            timeline.scrollLeft = 0;
          }
        }
        requestAnimationFrame(autoScroll);
      }

      timeline.addEventListener('mouseenter', () => { paused = true; });
      timeline.addEventListener('mouseleave', () => { paused = false; });
      timeline.addEventListener('touchstart', () => { paused = true; });
      timeline.addEventListener('touchend', () => {
        setTimeout(() => { paused = false; }, 2000);
      });

      requestAnimationFrame(autoScroll);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
